import { CircularProgress, type Theme, styled } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';

const Container = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
});

export type Props = {
  size?: number;
  sx?: SystemStyleObject<Theme>;
};

export const Loader = ({ size = 50, sx }: Props) => (
  <Container sx={sx}>
    <CircularProgress size={size} />
  </Container>
);
